import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/gallery", label: "Gallery" },
  { to: "/testimonials", label: "Testimonials" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => { setOpen(false); }, [loc.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${scrolled ? "bg-brand-navy/90 backdrop-blur-xl border-b border-white/10" : "bg-transparent"}`}
    >
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <span className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-white grid place-items-center shrink-0 overflow-hidden ring-2 ring-brand-gold shadow-md">
            <img src="/logo_mark.png" alt="WEDDING EVENTS logo" className="w-full h-full object-cover scale-105" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-serif text-xl sm:text-2xl text-white tracking-wide">WEDDING EVENTS</span>
            <span className="overline mt-1">We Create. You Celebrate.</span>
          </span>
        </Link>

        <div className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors ${isActive ? "text-brand-gold" : "text-white/80 hover:text-white"}`}
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/booking"
            data-testid="nav-book-cta"
            className="bg-brand-gold text-brand-navy text-sm font-semibold px-5 py-2.5 rounded-sm hover:-translate-y-0.5 hover:bg-[#e0bd4a] transition-transform"
          >
            Plan Your Event
          </Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-white p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden bg-brand-navy border-t border-white/10 px-5 pb-6 pt-2">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) => `block py-3 text-base border-b border-white/5 ${isActive ? "text-brand-gold" : "text-white/85"}`}
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/booking" className="mt-4 block text-center bg-brand-gold text-brand-navy font-semibold px-5 py-3 rounded-sm">
            Plan Your Event
          </Link>
        </div>
      )}
    </header>
  );
};
